export default __webpack_public_path__ + "static/card5-7fefa9ad616a3f2bf93c8ee56eeed951.webp";